export const isFetching = (state: any) => {
    return state.isFetching;
}

export const allCustomers = (state: any) => {
    return state.allCustomers
}